enum NotifikaciaTypEnum {
  NAMIETKA_URCENIE_GESTORSTVA = 'NAMIETKA_URCENIE_GESTORSTVA',
  ODMIETNUTIE_GESTORA = 'ODMIETNUTIE_GESTORA',
  PODPIS_PREDSEDU = 'PODPIS_PREDSEDU',
  PRICHOD_NOVEJ_AKTIVITY = 'PRICHOD_NOVEJ_AKTIVITY',
  ROKOVANIE_NR_SR = 'ROKOVANIE_NR_SR',
  SLEDOVANA_LEGISLATIVNA_OBLAST = 'SLEDOVANA_LEGISLATIVNA_OBLAST',
  SLEDOVANA_LEGISLATIVNA_OBLAST_PI = 'SLEDOVANA_LEGISLATIVNA_OBLAST_PI',
  SLEDOVANY_MATERIAL = 'SLEDOVANY_MATERIAL',
  SPUSTENIE_MPK = 'SPUSTENIE_MPK',
  UKONCENIE_AKT_EU = 'UKONCENIE_AKT_EU',
  ZACIATOK_AKT_EU = 'ZACIATOK_AKT_EU',
  ZACIATOK_ROKOVANIA_POV = 'ZACIATOK_ROKOVANIA_POV',
  ZMENA_PREDKLADATELA = 'ZMENA_PREDKLADATELA',
  ZMENA_STUPNA_DOLEZITOSTI = 'ZMENA_STUPNA_DOLEZITOSTI',
  ZRUSENIE_MPK = 'ZRUSENIE_MPK',
  VYHLASENE_PREDPISY = 'VYHLASENE_PREDPISY',
  NAHLASENIE_CHYBY = 'NAHLASENIE_CHYBY',
  PREDBEZNE_STANOVISKO = 'PREDBEZNE_STANOVISKO',
  DOPLNENE_PREDBEZNE_STANOVISKO = 'DOPLNENE_PREDBEZNE_STANOVISKO',
}

function notifikaciaTypNazov(notifikaciaTypEnum: NotifikaciaTypEnum | string): string {
  switch (notifikaciaTypEnum) {
    case NotifikaciaTypEnum.NAMIETKA_URCENIE_GESTORSTVA:
      return 'Notifikácia o podaní námietky k určeniu gestora';
    case NotifikaciaTypEnum.ODMIETNUTIE_GESTORA:
      return 'Notifikácia o odmietnutí gestora';
    case NotifikaciaTypEnum.PODPIS_PREDSEDU:
      return 'Notifikácia s dokumentami na podpis predsedovi vlády';
    case NotifikaciaTypEnum.PRICHOD_NOVEJ_AKTIVITY:
      return 'Notifikácia o príchode nových úloh';
    case NotifikaciaTypEnum.ROKOVANIE_NR_SR:
      return 'Notifikácia na podateľňu NR SR';
    case NotifikaciaTypEnum.SLEDOVANA_LEGISLATIVNA_OBLAST:
      return 'Notifikácia o sledovanej právnej oblasti';
    case NotifikaciaTypEnum.SLEDOVANA_LEGISLATIVNA_OBLAST_PI:
      return 'Notifikácia o sledovanej právnej oblasti';
    case NotifikaciaTypEnum.SLEDOVANY_MATERIAL:
      return 'Notifikácia o sledovanom procese';
    case NotifikaciaTypEnum.SPUSTENIE_MPK:
      return 'Notifikácia o spustení pripomienkového konania';
    case NotifikaciaTypEnum.UKONCENIE_AKT_EU:
      return 'Notifikácia o ukončení aktu EÚ';
    case NotifikaciaTypEnum.ZACIATOK_AKT_EU:
      return 'Notifikácia o začiatku aktu EÚ';
    case NotifikaciaTypEnum.ZACIATOK_ROKOVANIA_POV:
      return 'Notifikácia o začiatku rokovania POV';
    case NotifikaciaTypEnum.ZMENA_PREDKLADATELA:
      return 'Notifikácia o príchode nových úloh (zmena predkladateľa)';
    case NotifikaciaTypEnum.ZMENA_STUPNA_DOLEZITOSTI:
      return 'Notifikácia o zmene stupňa dôležitosti aktu EÚ';
    case NotifikaciaTypEnum.ZRUSENIE_MPK:
      return 'Notifikácia o zrušení pripomienkového konania';
    case NotifikaciaTypEnum.VYHLASENE_PREDPISY:
      return 'Notifikácia o vyhlásených predpisoch';
    case NotifikaciaTypEnum.NAHLASENIE_CHYBY:
      return 'Notifikácia o nahlásení chyby';
    case NotifikaciaTypEnum.PREDBEZNE_STANOVISKO:
      return 'Notifikácia o doručení predbežného stanoviska';
    case NotifikaciaTypEnum.DOPLNENE_PREDBEZNE_STANOVISKO:
      return 'Notifikácia o doručení doplneného predbežného stanoviska';
    default:
      return notifikaciaTypEnum;
  }
}

export {
  NotifikaciaTypEnum, notifikaciaTypNazov,
};
